import { render, staticRenderFns } from "./android.vue?vue&type=template&id=fd02e3c2&scoped=true&"
import script from "./android.vue?vue&type=script&lang=ts&"
export * from "./android.vue?vue&type=script&lang=ts&"
import style0 from "./android.vue?vue&type=style&index=0&id=fd02e3c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd02e3c2",
  null
  
)

export default component.exports